import React, { FC, memo, ReactNode, useCallback } from 'react';
import { useAppDispatch, useAppSelector } from 'app/config/storeConfig/hooks';
import { StepperModal, stepperModalActions } from 'features/StepperModal';
import { getOpenedState, getSteps } from '../model/selectors';
import { changePricesModalActions } from '../model/slice/changePricesModalSlice';
import { useWatchStep } from '../utils/hooks/useWatchStep';
import { ChangePricesStep } from './steps/ChangePricesStep';
import { SelectSizesStep } from './steps/SelectSizesStep';
import { SelectWarehouseStep } from './steps/SelectWarehouseStep';

export const ChangePricesModal: FC = memo(() => {
  const dispatch = useAppDispatch();

  const isOpened = useAppSelector(getOpenedState);
  const steps = useAppSelector(getSteps);

  useWatchStep();

  const closeModal = useCallback(() => {
    dispatch(changePricesModalActions.resetModalState());
    dispatch(stepperModalActions.changeActiveStepIndex(0));
  }, [dispatch]);

  const stepsContent: ReactNode[] = [
    <SelectWarehouseStep key="1" />,
    <SelectSizesStep key="2" />,
    <ChangePricesStep key="3" onClose={closeModal} />,
  ];

  return <StepperModal isOpened={isOpened} onClose={closeModal} steps={steps} stepsContent={stepsContent} width={1129} />;
});
